module.exports = __webpack_public_path__ + "img/uk-cerebrovascular-disease-male.fea3e0c3.png";